import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Link } from 'react-scroll'
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'

const slides = [
    {
        id: 1,
        image: "https://images.pexels.com/photos/3938022/pexels-photo-3938022.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Leading the way in innovative medical equipment solutions",
        subtitle: "Trusted by healthcare facilities across Ghana and beyond",
    },
    {
        id: 2,
        image: "https://images.pexels.com/photos/4562895/pexels-photo-4562895.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Discover cutting-edge medical technology for better patient outcomes",
        subtitle: "State-of-the-art equipment from leading international brands",
    },
    {
        id: 3,
        image: "https://images.pexels.com/photos/287237/pexels-photo-287237.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        title: "Elevating medical care with state-of-the-art equipment solutions",
        subtitle: "Your trusted partner for medical supplies and biomedical engineering services",
    },
]

export default function MYCarousel() {
    const [currentSlide, setCurrentSlide] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length)
        }, 6000)
        return () => clearInterval(timer)
    }, [])

    const goToSlide = (index) => {
        setCurrentSlide(index)
    }

    const goToPrevious = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
    }

    const goToNext = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length)
    }

    return (
        <div id="home" className="relative w-full overflow-hidden" style={{ height: 'calc(100vh - 80px)', marginTop: '80px' }}>
            <AnimatePresence mode="wait">
                <motion.div
                    key={currentSlide}
                    initial={{ opacity: 0.9 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0.9 }}
                    transition={{ duration: 0.3 }}
                    className="absolute inset-0"
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-medical-blue-900/70 via-medical-blue-800/60 to-medical-teal-800/60 z-10"></div>
                    <img
                        src={slides[currentSlide].image}
                        alt={slides[currentSlide].title}
                        className="w-full h-full object-cover"
                    />
                </motion.div>
            </AnimatePresence>

            {/* Content Overlay */}
            <div className="absolute inset-0 z-20 flex items-center justify-center py-8 sm:py-12">
                <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={currentSlide}
                            initial={{ opacity: 0.9, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0.9, y: -20 }}
                            transition={{ duration: 0.4 }}
                            className="px-2 sm:px-0"
                        >
                            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight text-balance">
                                {slides[currentSlide].title}
                            </h1>
                            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-6 sm:mb-8 max-w-3xl mx-auto px-2">
                                {slides[currentSlide].subtitle}
                            </p>
                            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center">
                                <Link
                                    to="products"
                                    spy={true}
                                    smooth={true}
                                    offset={-120}
                                    duration={500}
                                    className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-medical-blue-600 text-white font-semibold rounded-lg hover:bg-medical-blue-700 transition-all duration-200 shadow-xl hover:shadow-2xl cursor-pointer transform hover:scale-105 text-sm sm:text-base"
                                >
                                    View Products
                                </Link>
                                <Link
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    offset={-100}
                                    duration={500}
                                    className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 transition-all duration-200 cursor-pointer transform hover:scale-105 text-sm sm:text-base"
                                >
                                    Contact Sales
                                </Link>
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </div>

            {/* Navigation Arrows - Hidden on mobile */}
            <button
                onClick={goToPrevious}
                className="hidden md:block absolute left-4 top-1/2 -translate-y-1/2 z-30 p-3 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all duration-200 text-white"
                aria-label="Previous slide"
            >
                <HiChevronLeft className="w-6 h-6" />
            </button>
            <button
                onClick={goToNext}
                className="hidden md:block absolute right-4 top-1/2 -translate-y-1/2 z-30 p-3 bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/30 transition-all duration-200 text-white"
                aria-label="Next slide"
            >
                <HiChevronRight className="w-6 h-6" />
            </button>

            {/* Dots Indicator */}
            <div className="absolute bottom-4 sm:bottom-8 left-1/2 -translate-x-1/2 z-30 flex gap-2">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => goToSlide(index)}
                        className={`h-2 rounded-full transition-all duration-300 ${
                            index === currentSlide
                                ? 'w-8 bg-white'
                                : 'w-2 bg-white/50 hover:bg-white/75'
                        }`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </div>
    )
}
